import useAllDocumentsQuery from 'hooks/useAllDocumentsQuery'
import { useMemo } from 'react'
import calculateTreeData from 'utils/calculateTreeData'
import getNestedDocuments from 'utils/getNestedDocuments'
import { withPrefix } from 'utils/prefix'

export default function useNestedDocuments(path, { withoutParent } = {}) {
	const { edges } = useAllDocumentsQuery()

	return useMemo(() => {
		const { items } = calculateTreeData(edges, null, null)
		const nested = getNestedDocuments(path, items)

		return withoutParent ? nested.filter(itm => withPrefix(itm.url) !== path) : [...nested]
	}, [edges, path, withoutParent])
}
